export const WaCheckbox = {
  /**
   * @type {OrderFormBySteps}
   */
  parent: null,
  WA_INSTANCE_URI: 'https://api.green-api.com/waInstance1101749741/CheckWhatsapp/48124431e99947f0abb327d2662121d415900a61fa7b453a87',

  async init() {
    this.listenCheckbox();
  },

  listenCheckbox() {
    /**
     * @type {HTMLInputElement}
     */
    const checkbox = this.parent.order.querySelector('#hasWhatsapp');
    if (checkbox !== null) {
      if (checkbox.checked) {
        this.toggleEmailRequired();
      }
      checkbox.addEventListener('change', (e) => {
        this.state = e.currentTarget.checked;
        this.toggleEmailRequired();
      });
    }
  },

  toggleEmailRequired() {
    const input = this.parent.order.querySelector('input[type="email"]');
    const label = this.parent.order.querySelector('label[for="email"] .text-danger');
    label.classList.toggle('d-none');
    input.required = !input.required;
  },

  setParent(parentClass) {
    this.parent = parentClass;
    return this;
  },
};
